// generated by Neptune Namespaces v4.x.x
// file: Art.StandardLib/Inspect/Inspected/index.js

(module.exports = require('./namespace'))

.addModules({
  Array:  require('./Array'),
  Core:   require('./Core'),
  Object: require('./Object'),
  String: require('./String')
});